import { makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    margin: "4px",
    border: "1px solid #C4C4C4",
    "& .MuiChip-root": {
      borderRadius: 2,
      width: "35%",
      height: "25px",
      backgroundColor: "#F0F0F0",
    },
    "& .MuiButtonBase-root": {
      margin: "0 !important",
    },
    "& .MuiInputBase-input": {
      border: "none !important",
      width: "75% !important",
      flexGrow: "0",
    },
    "& .MuiAutocomplete-endAdornment": {
      right:
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "unset"
          : null,
      left:
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "-183px"
          : null,
    },
    "& .MuiChip-deleteIcon": {
      marginRight:
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "unset"
          : null,
      marginLeft:
        window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "5px"
          : null,
    },
  },
  table: {
    minWidth: 650,
  },
  tooltip: {
    maxWidth: "160px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12,
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075",
    },
    color: "white",
    fontSize: 15,
  },
  dialogPaper: {
    minWidth: "950px",
    borderRadius: "2px",
    overflowX: "hidden",
  },
  dialogHeader: {
    fontWeight: "bold",
    padding: "10px",
    fontSize: "14px",
  },
  dialogSubHeading: {
    width: "100%",
    height: "1px",
    backgroundColor: "#F0F0F0",
    fontSize: "12px",
    fontWeight: "bold",
    border: "1px solid #d7d7d7",
  },
  dialogFooter: {
    position: "relative",
    display: "flex",
    "justify-content": "space-between",
    padding: "10px",
    bottom: 0,
    width: "100%",
    "background-color": "#f0f0f0",
  },
  dialogContent: {
    width: "100%",
    justifyContent: "space-between",
    fontFamily: "Open Sans !important",
    fontSize: "14px !important",
  },
  dialogContentMethod: {
    width: "58%",
    justifyContent: "space-between",
    fontFamily: "Open Sans !important",
    fontSize: "14px !important",
    display: "flex",
  },
  cancelButton: {
    cursor: "pointer",
    "border-radius": "0px",
    border: "1px solid grey",
    width: "60px",
    height: "30px",
    margin: "0px 10px",
  },
  publishButton: {
    cursor: "pointer",
    "border-radius": "0px",
    border: "1px solid blue",
    width: "60px",
    height: "30px",
    margin: "0px 10px",
  },
  inputField: {
    borderRadius: "10px",
    width: "70%",
  },
  inputBox: {
    marginLeft: "10px",
    borderRadius: "10px",
    width: "430px",
    display: "block",
    overflowY: "auto",
  },
  bodyTab1: {
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left",
    font: "normal normal 600 12px/17px Open Sans;",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
  },
  tab: {
    marginRight:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "0px"
        : "40px",
    marginLeft:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "40px"
        : "0px",
    verticalAlign: "middle",
    cursor: "pointer",
  },
  activeTab: {
    color: "var(--brand_color2)",
    paddingBottom: "7px",
    borderBottom: "3px solid var(--brand_color2)",
    marginRight:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "0px"
        : "40px",
    marginLeft:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "40px"
        : "0px",
    verticalAlign: "middle",
    cursor: "pointer",
  },
}));

const FunctionDefinition = (props) => {
  const { t } = useTranslation(["styles", "translation"]);
  const translationStyles1 = window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";


  const [fName, setFName] = useState(
    props?.prevValue[0]?.restEndPoint || props?.functionName?.current || ""
  );
  const [URL, setURL] = useState(
    props?.prevValue[0]?.url || props?.endpointURL?.current || ""
  );

  useEffect(() => {
  if(props?.isMF){
  setFName(props?.functionName?.current)
  setURL(props?.endpointURL?.current)
  }
}, [fName, URL, props?.functionName?.current ,props?.endpointURL?.current, props.isMF])

  useEffect(() => {
    if (!props?.isMF) {
      props.functionName.current = fName;
      props.endpointURL.current = URL;
      if (fName !== "" && URL !== "") {
        props?.setIsDefineParameters(true);
      }else{
        props?.setIsDefineParameters(false);
      }
    }
  }, [fName, URL]);

  const handleFunctionNameChange = (ev) => {
    const value = ev.target.value;
    const alphanumericValue = value.replace(/[^a-zA-Z0-9\s]/g, '');

    const startsWithAlphabet = /^[a-zA-Z]/.test(alphanumericValue);

    if (startsWithAlphabet) {
      setFName(alphanumericValue);
    } else {
      setFName('');
    }
  }

  const handleEndpointChange = (ev) => {
      setURL(ev.target.value);
  }

  const classes = useStyles();

  return (
    <>
      <div style={{ height: "54px", fontWeight: "bold", display: "flex" }}>
        <div
          className={classes.dialogContent}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <label
            aria-label={"function Name"}
            for="functionName"
            style={translationStyles1 ? { marginRight: "10px", opacity: "0.8", textAlign: "right"} : { marginRight: "10px", opacity: "0.8" }}
          >
            {t("translation:Function_Name")}
            <b style={{ color: "rgb(213, 61, 61" }}>*</b>
          </label>

          <input
            aria-label={"Function Name"}
            autoComplete="off"
            type="text"
            for="functionName"
            maxLength={200}
            value={fName}
            className={classes.inputField}
            onChange={handleFunctionNameChange}
            disabled={props?.isMF || props?.prevValue[0]?.status === "0"}
            required
          />
        </div>

        <div
          className={classes.dialogContent}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <label
            aria-label={"endpoint Url"}
            for="endpointUrl"
            style={translationStyles1 ? { marginRight: "10px", opacity: "0.8", textAlign: "right"} : { marginRight: "10px", opacity: "0.8" }}
          >
            {t("translation:Rest_End_Point_URL")}
            <b style={{ color: "rgb(213, 61, 61" }}>*</b>
          </label>

          <input
            aria-label={"Endpoint URL"}
            autoComplete="off"
            type="text"
            value={URL}
            maxLength={200}
            id="endpointUrl"
            className={classes.inputField}
            onChange={handleEndpointChange}
            disabled={props?.isMF || props?.prevValue[0]?.status === "0"}
            required
          />
        </div>
      </div>
    </>
  );
};

export default FunctionDefinition;
